// extracted by mini-css-extract-plugin
module.exports = {"root":"Color_root__3gARr","item":"Color_item__3U_uU","button":"Color_button__3y4wg","active":"Color_active__26xU1","color":"Color_color__2LlJ_"};